import letters from 'assets/images/bwtext.jpg';
import term from 'assets/images/term3.jpg';
import { useTranslation } from 'react-i18next';
import { EpdLinks } from 'routes/EpdRoutes';
import { EPDModel } from 'services/EpdClient';
import styled from 'styled-components';
import DebugOnly from 'util/dev-tools/DebugOnly';
import { formatDate } from 'util/utils';

import { Card, CardHeading, CardName, CardSmallText, CardStatus } from './styles';

type TProps = {
  epd: EPDModel;
  background: any;
};

const EpdCard = ({ epd, background }: TProps) => {
  const { t } = useTranslation();

  return (
    <Card to={EpdLinks.epd(epd.id)} background={background}>
      <div>
        <DebugOnly style={{ opacity: 0.1 }}>
          {epd?.isCompilerFormat && (
            <ImageMixer>
              <img src={term} alt="" />
              <img src={letters} alt="" />
            </ImageMixer>
          )}
        </DebugOnly>
        <CardHeading>{epd.fullIdentificationNumber}</CardHeading>
        <CardName>{epd.title}</CardName>
      </div>
      <div>
        <CardSmallText>{epd?.isCompilerFormat ? 'EPD Compiler format' : 'Standard EPD format'}</CardSmallText>
        <CardSmallText>
          {epd?.publicVersionDate &&
          !epd.publicVersionDate.toString().startsWith('1900') &&
          !epd.publicVersionDate.toString().startsWith('0001')
            ? `Published: ${formatDate(epd?.publicVersionDate)}`
            : `Created: ${formatDate(epd?.createdAt)}`}
        </CardSmallText>
        {epd.epdState && (
          <CardStatus status={epd.epdState.statusDisplayName}>
            {t(`epdWizard.epdState.status.${epd.epdState.statusDisplayName}`)}
          </CardStatus>
        )}
      </div>
    </Card>
  );
};

const ImageMixer = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  img {
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;
    height: 30%;
    object-fit: cover;
  }
  & :nth-child(2) {
    mix-blend-mode: multiply;
  }
`;

export default EpdCard;
